import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Modal } from 'flowbite';
import moment from 'moment';
import { IBookingDetails } from 'src/app/models/booking/bookingDetails';
import { InputType } from 'src/app/models/enums';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';

@Component({
    selector: 'app-modal-ticketing-status',
    templateUrl: './modal-ticketing-status.component.html',
    styleUrl: './modal-ticketing-status.component.scss',
    standalone: false
})
export class ModalTicketingStatusComponent implements OnChanges {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() booking: IBookingDetails;
  @Output() action = new EventEmitter<any>();

  public originalBooking: IBookingDetails;
  public updated: boolean = false;
  public changes: string[] = [];

  public InputType = InputType;
  public images = images;
  public moment = moment;

  public showResendTicket: boolean = false;
  public confirmResendTicket: boolean = false;
  public resendRelatedTicket: boolean = true;
  public relatedBookingsInfo: any = [];

  constructor(public literalService: LiteralService) {}

  ngOnChanges(): void {
    if (this.confirmResendTicket) this.confirmResendTicket = false;
    this.originalBooking = { ...this.booking };
    if (this.booking && this.booking.paidDateTime && this.booking.price > 0) {
      this.showResendTicket = true;
      this.relatedBookingsInfo = [];
      if (this.booking.relatedBookings) {
        this.booking.relatedBookingsInfo.map((bookingDetail: IBookingDetails) => {
          this.relatedBookingsInfo.push(
            `${bookingDetail.origin.name} - ${bookingDetail.destination.name}, ${moment(bookingDetail.availability.dateTime).format('HH:mm - ddd - DD/MM/YYYY')}`
          );
        })
      }
    }
  }

  updateStatus(event: Event) {
    this.updated = true;
    event?.stopPropagation();
  }

  checkChanges() {
    this.changes = [];
    const originalPaidDateTime = this.originalBooking.paidDateTime ? moment(this.originalBooking.paidDateTime).format('DD/MM/YYYY') : undefined;
    const originalValidatedDateTime = this.originalBooking.validatedDateTime ? moment(this.originalBooking.validatedDateTime).format('DD/MM/YYYY') : undefined;
    const paidDateTime = this.booking.paidDateTime ? moment(this.booking.paidDateTime).format('DD/MM/YYYY') : undefined;
    const validatedDateTime = this.booking.validatedDateTime ? moment(this.booking.validatedDateTime).format('DD/MM/YYYY') : undefined;
    originalPaidDateTime !== paidDateTime && this.changes.push('payment');
    originalValidatedDateTime !== validatedDateTime && this.changes.push('validation');
  }

  changePayment() {
    if (this.booking) {
      if (this.booking.paidDateTime === undefined || this.booking.paidDateTime === null) {
        this.booking.paidDateTime = moment().toString();
      } else {
        this.booking.paidDateTime = undefined;
        // If paid is set to false, validated must also be false
        this.booking.validatedDateTime = undefined;
      }
    }
    this.checkChanges();
  }

  changeValidation() {
    if (this.booking) {
      if (this.booking.validatedDateTime === undefined || this.booking.validatedDateTime === null) {
        this.booking.validatedDateTime = moment().toString();
        // If validated is set to true, paid must also be true
        if (!this.booking.paidDateTime) {
          this.booking.paidDateTime = moment().toString();
        }
      } else {
        this.booking.validatedDateTime = undefined;
      }
    }
    this.checkChanges();
  }

  onSubmit() {
    if (this.confirmResendTicket) this.action.emit({sendRelated: this.resendRelatedTicket});
    else {
      this.action.emit();
      this.updated = false;
    }
    this.modal.toggle();
  }
}
